<template>
  <div class="vld-parent" ref="subscriptions">
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-3 mb-5">
              Aqui você confere todas suas inscrições nas chamadas de startups
              Stars. Ao selecionar uma inscrição, é possível visualizar as
              informações que foram submetidas na ficha de inscrição da chamada.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--8">
      <div class="row">
        <div class="col">
          <startup-call-list
            v-if="!empty"
            :data="calls"
            :onlyShowButton="true"
          />
          <div v-else class="row">
            <div class="col-12 text-center">
              <badge type="info" class="bg-white">
                A startup não está inscrita em nenhuma chamadas Stars até o
                momento.</badge
              >
            </div>
          </div>
        </div>
      </div>
      <hr class="mt-5 mb-1" />
      <div class="row">
        <div class="col text-right">
          <base-button
            type="link"
            :custom="true"
            @click="$router.push('/startup/chamadas')"
            >Voltar</base-button
          >
        </div>
      </div>
    </div>
    <modal
      :show.sync="showModal"
      modal-classes="modal-dialog-centered modal-default"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Atenção!
      </h6>
      <div class="text-center">
        <i class="fa fa-exclamation-circle fa-3x"></i>
        <h4 class="heading mt-4">Prezado(a),</h4>
        <p class="my-4">
          Não foi encontrado nenhum registro de inscrição da startup nas
          <span class="text-warning font-weight-400">chamadas STARS</span>. Em
          caso de dúvidas, sinta-se livre para
          <base-button
            type="danger"
            class="ml-auto"
            size="sm"
            @click="$router.push('/startup/suporte')"
            >Contatar o suporte
          </base-button>
        </p>
        <p class="text-right mt-4">
          Cordialmente,<br />
          <span class="font-weight-600"
            >Equipe <span class="text-warning">STARS</span></span
          >.
        </p>
      </div>
      <template slot="footer">
        <base-button type="white" @click="$router.push('/')">
          Voltar ao menu inicial
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import api from "@/services/api";

import StartupCallList from "@/components/StartupCallList";

export default {
  name: "inscricoes",
  components: {
    StartupCallList,
  },
  data() {
    return {
      calls: [],
      empty: false,
      showModal: false,
    };
  },
  async mounted() {
    let loader = this.$loading.show({
      container: this.$refs.subscriptions,
      width: 180,
      height: 180,
      color: "#ffffff",
      backgroundColor: "transparent",
    });
    try {
      const { data: subscriptions } = await api.get(
        "/startup-call-subscriptions"
      );
      if (!subscriptions.length) {
        loader.hide();
        this.empty = this.showModal = true;
        return;
      }
      subscriptions.forEach((subscription) => {
        const call = subscription.startupCall;
        if (call) {
          call.subscription_id = subscription.id;
          this.calls.push(call);
        }
      });
      loader.hide();
    } catch (e) {
      this.$toasted.error("Ocorreu um erro ao recuperar as informações");
    }
  },
  methods: {
    handleViewSubscription(subscriptionId) {
      this.$router.push(`/startup/inscricoes/${subscriptionId}/visualizar`);
    },
    truncate(text, stop = 50, clamp) {
      if (!clamp && text.slice(-1) !== ".") clamp = ".";
      return (
        text.slice(0, stop) + (stop < text.length ? clamp || "..." : clamp)
      );
    },
  },
};
</script>
<style scoped>
.card {
  margin-top: 10px;
}
.card-date {
  font-weight: 500;
  display: block;
  text-align: right;
  font-size: 13px;
  margin-top: 5px;
  text-transform: uppercase;
}
.card-img-top {
  display: block;
  max-width: 190px;
  max-height: 190px;
  width: auto;
  height: auto;
  margin: 0 auto;
}

h5.card-title {
  text-align: center;
  font-size: 1em;
  font-weight: 600;
}
</style>
